var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Log out of your account?")]),_c('SubmitButton',{attrs:{"text":"Log Out"},on:{"click":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }